export function parseTagsCsv(value: string | null | undefined): string[] {
  if (!value) return [];
  return value
    .split(/[,、]/)
    .map((tag) => tag.trim())
    .filter((tag) => tag.length > 0);
}
